module.exports = __webpack_public_path__ + "static/media/lanetalk_logo.e3b6e40e.svg";